export default __webpack_public_path__ + "static/media/mode-38.f538a4e3.svg";